import { ApiButtonEvent, ButtonEvent } from '@unive/analytics';

export function mapButtonEvent(event: ButtonEvent): ApiButtonEvent {
  return {
    knop_interactie: {
      naam: event.name,
      type: event.type,
      locatie: event.location,
    },
  };
}
